import MoneyInput from '~/components/MoneyInput.jsx';

const EditPaymentQuestionForm = ({ settings, setSettings }) => {
    return (
        <div>
            <MoneyInput
                label="Amount"
                className="mt-4"
                value={settings?.amount || ''}
                onChange={value => setSettings({ ...settings, amount: value })}
            />
            <div className="mb-4 text-sm mx-4 mt-1 text-gray-500">
                This will require payments to pay this amount to submit the
                form.
            </div>
        </div>
    );
};

export default EditPaymentQuestionForm;
